export default "/assets/ico-arrow-left.png";